import * as React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { ProcesName } from '../containers/helpers/ProcesHandlerHelpers';
import { FormControlProps } from '../interfaces/FormControlProps';

let instance = null;

export class ReCaptcha extends React.Component<FormControlProps> {
  private reCaptchaRef: any;

  constructor(props: FormControlProps) {
    super(props);
    this.reCaptchaRef = React.createRef();
  }

  componentDidMount() {
    if (!this.props.formConfig.handlers) {
      this.props.formConfig.handlers = [];
    }

    // Set an instance reference outside this component, because it gets destroyed on submitting
    instance = this.reCaptchaRef.current;
    
    this.props.formConfig.handlers.push({
      // Execute ReCaptcha validation When submitting form to backend
      procesName: ProcesName.Put_preprocess,
      execute: (component, data, onSuccess, onError) => {
        instance.executeAsync().then(token => {
          data[this.props.formFieldDefinition.name] = token;
          onSuccess(data);
        });
      },
    });
  }

  render() {
    return (
      <>
      <div className='form-control-recaptcha'>
        <ReCAPTCHA
                  ref={this.reCaptchaRef}
                  sitekey={this.props.formFieldDefinition.siteKey}
                  size="invisible"
                  badge="inline"
              />
      </div>
      </>
    );
  }
}
